/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Card from "../Card";
import Switch from "../Switch";
import L from "../Lang";
import Alert from "../Alert";

export default class AccountPricingManager extends BaseCom {
    async componentDidMount() {
        await this.load();
    }

    async componentDidUpdate(prevProps) {
        await this.fillListAsync('/api/account/type/list', 'accountTypes');
        if (this.props.account?.id !== prevProps.account?.id) {
            await this.load();
        }
    }

    load = async () => {
        if (!this.props.account)
            return;
        try {
            let j = await qreq.postAsync('/api/product/list', {});
            if (j.list) {
                j.list.forEach(p => {
                    let attr = this.props.account?.productAttributes?.find(ap => ap.productID === p.id);
                    if (!attr)
                        return;
                    let price = attr?.price;
                    let upfrontFee = attr?.upfrontFee;
                    if (price)
                        p.customPrice = price;
                    if (p.customPrice === 0)
                        p.customPrice = null;
                    if (upfrontFee)
                        p.upfrontFee = upfrontFee;
                    if (p.upfrontFee === 0)
                        p.upfrontFee = null;
                    p.isActive = attr?.isActive;
                });
                j.list.sort((a, b) => a.productName.localeCompare(b.name));
                this.setState({ productList: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
        }
    }


    changePrice = (e, product) => {
        let val = Number(e.target.value);
        if (val)
            product.customPrice = val;
        else
            product.customPrice = 0;
        this.setState({ productList: [...this.state.productList] });
        this.props.onPriceChange(product);
    }

    changeUpfrontFee = (e, product) => {
        let val = Number(e.target.value);
        if (!val)
            val = 0;
        product.upfrontFee = val;
        this.setState({ productList: [...this.state.productList] });
        this.props.onPriceChange(product);
    }

    changeIsActive = (e, product) => {
        let val = e.target.checked;
        product.isActive = val;
        this.setState({ productList: [...this.state.productList] });
        this.props.onPriceChange(product);
    }

    render() {
        const at = this.state.accountTypes?.find(x => x.id === this.props.account?.accountTypeID);
        if (at?.level !== 0 && at?.level !== 3) return;
        return (
            <Card title="Pricing Manager">
                <Alert type="info"><L>Enable is now on the left.</L></Alert>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th><L>Enable</L></th>
                            <th><L>Manufacturer</L></th>
                            <th><L>Product</L></th>
                            {/*<th><L>Size</L></th>*/}
                            <th><L>Units</L></th>
                            <th><L>Unit Price</L></th>
                            <th><L>Upfront Fee</L></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.productList?.map((p, idx) => (
                            <tr key={idx} className={p.isActive ? '' : 'text-decoration-line-through'}>
                                <td>
                                    <Switch
                                        checked={p.isActive}
                                        onChange={(e) => {
                                            this.changeIsActive(e, p);
                                        }} />
                                </td>
                                <td>{p.manufacturer}</td>
                                <td>{p.productName}</td>
                                <td>{p.units}</td>
                                {/*<td>{p.productSize}</td>*/}
                                <td><input
                                    value={p.customPrice}
                                    type="text"
                                    step="0.01"
                                    className="form-control"
                                    onChange={(e) => this.changePrice(e, p)}
                                    disabled={!p.isActive}
                                /></td>
                                <td>
                                    <input
                                        value={p.upfrontFee}
                                        type="text"
                                        step="0.01"
                                        className="form-control"
                                        onChange={(e) => this.changeUpfrontFee(e, p)}
                                        disabled={!p.isActive}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        );
    }
}